<template>
  <section
    :class="{ greenav: $route.name !== 'Home', error: $route.name === 'Error' || $route.name === 'proximamente', upnav: ($route.name == 'Home' && scrollP > 2105 || $route.name != 'Home') }">
    <div class="modal-container" :class="{ nonemodal: mdadd == false }">
      <modalCar @close="mdadd = false" :class="{ transitionL: mdadd == true }" />
    </div>

    <div class="contenedor"
      :class="{ bkhome: scrollP > 100 && $route.name == 'Home', bknav: scrollP > 100 && $route.name !== 'Home', ptop1: identity.name }">

      <div class="dflx">
        <div class="logo">
          <a href="/">
            <img src="../../assets/logotipo_blanco.png" alt="" v-if="$route.name === 'Home'" />
            <img src="../../assets/logotipo_amarillo.png" alt=""
              v-else-if="$route.name === 'Error' || $route.name === 'proximamente'" />
            <img src="../../assets/logotipo_red.png" alt="" v-else />
          </a>
        </div>

        <div class="notis" @click="mdadd = true">
          <img src="../../assets/notificaciones.svg" alt="" v-if="$route.name === 'Home'" />
          <img src="../../assets/notificaciones.svg" alt=""
            v-else-if="$route.name === 'Error' || $route.name === 'proximamente'" />
          <img src="../../assets/notificacionesG.svg" alt="" v-else />
          <div v-if="carrito !== ''"><sub>{{ carrito.items.length }}</sub></div>
          <div v-else><sub>0</sub></div>
        </div>

        <div class="menu" @click="menuDespliegue">
          <img src="../../assets/Hamburguer.png" alt="" v-if="$route.name === 'Home'" />
          <img src="../../assets/Hamburguer.png" alt=""
            v-else-if="$route.name === 'Error' || $route.name === 'proximamente'" />
          <img src="../../assets/HamburguerG.png" alt="" v-else />
        </div>

        <div class="contacto">
          <p>
            <span class="asterisco">*</span><a href="mailto: contacto@porkilo.mx">contacto@porkilo.mx</a>
          </p>
        </div>

        <div class="notificaciones" @click="mdadd = true">
          <div>
            <img src="../../assets/notificaciones.svg" alt="" v-if="$route.name === 'Home'" />
            <img src="../../assets/notificaciones.svg" alt=""
              v-else-if="$route.name === 'Error' || $route.name === 'proximamente'" />
            <img src="../../assets/notificacionesG.svg" alt="" v-else />
          </div>
          <div v-if="carrito !== ''"><sub>{{ carrito.items.length }}</sub></div>
          <div v-else><sub>0</sub></div>
        </div>
      </div>


    </div>


    <div id="backdrop" @click="menuCerrado"></div>
    <div id="despliegue">
      <img src="../../assets/x.png" alt="x" class="cerrar" @click="menuCerrado()">

      <p v-if="identity.name" class="nombre"> <span class="asterisco--header only-mov">*</span> {{ `¡Hola!
        ${identity.name.split(" ")[0]}` }}</p>

      <nav>
        <ul>
          <li> <span class="asterisco--header">*</span> <a href="/">home</a></li>
          <li>
            <span class="asterisco--header">*</span>
            <p @click="linkeado('menu'), menuCerrado()" class="pointer">menú de botanas</p>
          </li>
          <li><span class="asterisco--header">*</span><a href="/merchandise">merch</a></li>
          <li>
            <span class="asterisco--header">*</span>
            <a href="/administrador" v-if="(identity.role == 'legrafica') || (identity.role == 'admin')">perfil</a>
            <a href="/mi-cuenta/escritorio" v-else-if="(identity.role == 'cliente')">perfil</a>
            <a href="/login" v-else>perfil</a>
          </li>
        </ul>
      </nav>

      <div>
        <img src="../../assets/notificaciones.svg" alt="" @click="mdadd = true" />
        <sub v-if="carrito !== ''">{{ carrito.items.length }}</sub>
        <sub v-else>0</sub>
        <div class="barra_buscador">
          <div class="btn" @click="buscar()"></div>
          <input v-model="textoBuscar" type="text" placeholder="Buscador" @keydown.enter="buscar()" class="only-mov">
          <input v-model="textoBuscar" type="text" placeholder="Busca tu snack favorito" @keydown.enter="buscar()"
            class="only-pc">
        </div>
      </div>

      <ul class="contactos">
        <li> <span class="asterisco--header only-mov">*</span><a href="mailto: contacto@porkilo.mx">contacto@porkilo.mx</a></li>
      </ul>

      <div class="imagen__botana">
        <h3>Por</h3>
        <h3>Kilo</h3>
        <h3>Botanas</h3>
        <img src="../../assets/mano.png" alt="Mano Por Kilo">
      </div>
    </div>
  </section>
</template>

<script>
import modalCar from "../../views/carrito/modalCar";
import store from "../../components/store";
import { mapActions } from "vuex";
export default {
  name: "Header",
  data() {
    return {
      status: "error",
      message: "",
      mdadd: false,
      scrollP: localStorage.getItem("scroll"),
      textoBuscar: '',
    };
  },
  components: {
    modalCar,
    store,
  },
  async created() {
    await this.getIdentity();
    await this.obtenerCarritos();
  },
  computed: {
    carrito() {
      return this.$store.getters["carrito/getcar"];
    },
    identity() {
      return this.$store.getters["admin/getIdentity"];
    },
  },
  methods: {
    ...mapActions("carrito", ["getCart"]),
    ...mapActions("carrito", ["getCartCopy"]),
    ...mapActions("product", ["getAllInfoPrd"]),
    ...mapActions("category", ["getAllInfoCtg"]),
    ...mapActions("store", ["setAddedStr"]),
    ...mapActions("store", ["setBusquedaStr"]),

    async obtenerCarritos() {
      await this.getCart();
      await this.getCartCopy();
    },

    buscar() {
      this.menuCerrado()
      const path = window.location.pathname
      // this.setBusquedaStr(this.textoBuscar)
      if (this.textoBuscar != '') {
        if (path != "/") {
          this.setBusquedaStr(this.textoBuscar)
          this.$router.push("/").then(() => {
            window.scrollTo({
              top: 0,
              left: 0,
              behavior: "instant",
            });
          }).then(() => {
            document.documentElement.style.scrollBehavior = 'auto';
            document.body.style.scrollBehavior = 'auto';
            location.href = "#menu"
          }).then(() => {
            this.setAddedStr(this.textoBuscar)
            this.textoBuscar = '';
            setTimeout(() => {
              document.documentElement.style.scrollBehavior = 'smooth';
              document.body.style.scrollBehavior = 'smooth';
            }, 300);
          })
        } else {
          this.setAddedStr(this.textoBuscar)
          this.textoBuscar = '';

          
          this.$emit('header-buscar');
          this.$router.push("/");
          setTimeout(() => {
            location.href = "#menu__busqueda"
          }, 300);
        }
      }
    },

    linkeado(val) {
      const path = window.location.pathname;
      if (path != "/") {
        document.documentElement.style.scrollBehavior = 'auto';
        document.body.style.scrollBehavior = 'auto';
        this.setAddedStr("");
        this.$router.push("/").then(() => {
          setTimeout(() => {
            window.location.href = '#categorias'
          }, 500);

          setTimeout(function () {
            document.documentElement.style.scrollBehavior = 'smooth';
            document.body.style.scrollBehavior = 'smooth';
          }, 600);
        })

      } else {
        this.$emit('header-click');
      }
    },

    menuDespliegue() {
      const menu = document.getElementById("despliegue");
      const bd = document.getElementById("backdrop");
      menu.style.transform = 'translateX(0%)';
      bd.style.display = "block";
      setTimeout(() => (bd.style.opacity = "1"), 0);
    },

    menuCerrado() {
      const menu = document.getElementById("despliegue");
      const bd = document.getElementById("backdrop");
      menu.style.transform = "translateX(100%)";
      bd.style.opacity = "0";
      setTimeout(() => (bd.style.display = "none"), 600);
    },
    scroll(event) {
      let number = event.target.documentElement.scrollTop;
      let offset = number * 1;
      localStorage.setItem("scroll", offset);
      this.scrollP = localStorage.getItem("scroll");
    },
    getIdentity: async function () {
      let response = await this.$store.dispatch("admin/getData");
      return response;
    },

  },
  mounted() {
    window.addEventListener("scroll", this.scroll);
  },
};
</script>

<style scoped>
.contenedor {
  position: fixed;
  /*display: flex;*/
  z-index: 100;
  transition: .4s;
}

h1,
h2,
h3,
p,
ul {
  margin: 0;
  padding: 0;
}

.modal-container {
  opacity: 1;
  transition: 0.5s;
  position: relative;
  z-index: 1200;
}

sub {
  margin: 0;
  font-family: "Kinetica";
  font-style: normal;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #fff9ea;
}

img {
  width: 100%;
  height: 100%;
}

#despliegue {
  position: fixed;
  background-color: #FF3723;
  z-index: 124;
  transition: transform 0.3s linear;
}


.contacto a,
.contacto p,
.contacto__cel a,
.navegacion a {
  font-family: "Kinetica-Bold";
  font-style: normal;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #ffffff;
}

.contacto a,
.contacto__cel a,
.navegacion a {
  cursor: pointer;
}

.despliegue__img {
  position: relative;
}

.despliegue__img p {
  font-family: "Piknic-Regular";
  font-style: normal;
  font-weight: 400;
  text-align: center;
  text-transform: uppercase;
  color: #f6b801;
}

.despliegue__img p:last-of-type {
  letter-spacing: 0.04em;
  color: transparent;
}

.nonemodal {
  opacity: 0;
  pointer-events: none;
}

#despliegue {
  overflow-y: auto;
}

#despliegue>div:first-of-type input {
  color: #FFF9EA;
  font-family: Kinetica-Bold;
  font-style: normal;
  font-weight: 700;
  text-transform: uppercase;
  background-color: transparent;
  background-image: url("../../assets/lupa.svg");
  background-repeat: no-repeat;
}

.barra_buscador {
  position: relative;
}

.btn {
  width: 5.128205128205128VW;
  height: 5.128205128205128VW;
  position: absolute;
  z-index: 2;
  background-color: transparent;
  left: 4.246154VW;
  top: 2.579487VW;
}

#despliegue>div:first-of-type input::placeholder {
  color: #FFF9EA;
}

#despliegue ul {
  list-style: none;
}

#despliegue li {
  color: #FFF9EA;
  font-family: Kinetica-Bold;
  font-style: normal;
  font-weight: 700;
  text-transform: uppercase;
}

/* #despliegue li a::before,
#despliegue li p::before {
  font-family: Catou;
  content: '*';
  position: absolute;
  color: #CCC548;
} */

.imagen__botana h3 {
  text-align: center;
  color: #F6B801;
  font-family: Piknic-Regular;
  font-style: normal;
  font-weight: 400;
  text-transform: uppercase;
}

.imagen__botana h3:last-of-type {
  color: transparent;
}


.imagen__botana {
  position: relative;
}

.imagen__botana img {
  position: absolute;
}

.nombre {
  color: #CCC548;
  font-family: Kinetica-Bold;
  font-style: normal;
  font-weight: 700;
  text-transform: uppercase;
  position: absolute;
}

.greenav .asterisco {
  color: #FF3723;
}

.asterisco {
  font-family: 'Catou';
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #CCC548;
}

.error .asterisco {
  color: #CCC548 !important;
}

.asterisco--header {
  font-family: 'Catou';
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #CCC548;
}

/* Celular */
@media (max-width: 767px) {

  .only-pc {
    display: none;
  }

  /* #despliegue .nombre::before {
    font-family: Catou;
    content: '*';
    position: absolute;
    color: #CCC548;
    font-size: 8.176923VW;
    left: -6.1vw;
    transform: translateY(-10%)
  } */

  .nombre {
    font-size: 3.076923076923077VW;
    line-height: normal;
    letter-spacing: 0.1846153846153846VW;
  }

  .txt {
    text-align: center;
    color: #FFF;
  }

  .cerrar {
    width: 5.243589743589743VW;
    height: 3.8923076923076922VW;
    position: absolute;
    right: 5.269230769230769VW;
    top: 5.384615384615385VW;
  }

  #despliegue {
    height: 100%;
  }

  #despliegue nav {
    margin: 21.538462VW 0 8.307692VW 16.666666666666664VW;
  }

  #despliegue nav ul li {
    font-size: 3.076923076923077VW;
    line-height: normal;
    letter-spacing: 0.1846153846153846VW;
    position: relative;
    margin-bottom: 3.3333333333333335VW;
    display: flex;
    align-items: center;
  }

  #despliegue nav ul li:last-of-type {
    margin-bottom: 0;
  }

  /* #despliegue nav ul li a::before,
  #despliegue nav ul li p::before {
    font-size: 8.176923VW;
    left: -6.1vw;
    transform: translateY(-10%);
  } */

  #despliegue>div:first-of-type {
    display: flex;
    align-items: end;
    position: relative;
    margin-bottom: 8.846153846153847VW;
  }

  #despliegue>div:first-of-type>img {
    width: 7.6923076923076925VW;
    height: 7.948717948717948VW;
    margin: 0 7.179487179487179VW 0 11.025641025641026VW;
  }

  #despliegue>div:first-of-type sub {
    background-color: #194C06;
    border-radius: 100%;
    padding: 0 1vw;
    position: absolute;
    left: 17.076923076923077VW;
  }

  #despliegue>div:first-of-type input {
    width: calc(64.35897435897436VW - (2 * 11.538461538461538VW));
    height: 8.974358974358974VW;
    border: 0.5128205128205128VW solid #FFF9EA;
    border-radius: 25.64102564102564VW;
    padding: 0 11.538461538461538VW;
    font-size: 2.564102564102564VW;
    line-height: normal;
    letter-spacing: 0.38461538461538464VW;
    background-size: 5.128205128205128VW 5.128205128205128VW;
    background-position: 3.8461538461538463VW 2.1794871794871793VW;
  }

  .contactos {
    margin-left: 16.923076923076923VW;
  }

  .contactos li {
    font-size: 2.564102564102564VW;
    line-height: normal;
    letter-spacing: 0.15384615384615385VW;
    position: relative;
    display: flex;
    align-items: center;
  }

  .contactos li:not(:last-of-type) {
    margin-bottom: 2.051282051282051VW;
  }

  /* .contactos li a::before {
    font-size: 6.8141025VW;
    left: -5.1vw;
    top: -1.1vw;
  } */

  .imagen__botana img {
    width: 81.53846153846153VW;
    height: 117.94871794871796VW;
    top: 5.512820512820513VW;
    right: 4.615384615384616VW;
  }

  .imagen__botana h3:first-of-type {
    padding-top: 5.410256VW;
  }

  .imagen__botana h3:not(:last-of-type) {
    font-size: 58.97435897435898VW;
    line-height: 78%;
  }

  .imagen__botana h3:last-of-type {
    -webkit-text-stroke: 0.5128205128205128VW #F6B801;
    font-size: 28.205128205128204VW;
    line-height: 78%;
  }

  .contacto,
  .notificaciones {
    display: none;
  }

  .contacto,
  .notificaciones {
    display: none;
  }

  .contenedor {
    padding: 2.564102564102564vw 8.205128205128204vw 0 7.435897435897436vw;
    width: 84.35897435897436vw;
    align-items: center;
    justify-content: space-between;
  }

  .upnav .contenedor.bkhome {
    background-color: #FF3723;
  }

  .contenedor.bknav {
    background-color: #fff9ea;
  }

  .error .contenedor.bknav {
    background-color: #FF3723;
  }

  .error .contacto a,
  .error .contacto p {
    color: #FFF9EA !important;
  }

  /* .upnav .contacto a::before {
    color: #CCC548 !important;
  } */

  .contenedor .bkhome .notificaciones>div:last-of-type {
    background-color: #CCC548 !important;
  }

  .menu {
    width: 11.282051282051283vw;
    height: 7.6923076923076925vw;
  }

  .logo {
    width: 25.64102564102564vw;
    transition: .4s;
  }

  .upnav .logo {
    width: 36.9565vw;
    margin: 3vw 0 3vw;
  }

  #despliegue {
    right: 0;
    transform: translateX(100%);
    width: 100%;
  }

  .navegacion {
    margin: 2.2615384615384615vw 0 6.307692vw 16.666666666666664vw;
    position: relative;
  }

  .navegacion a {
    font-size: 3.076923076923077vw;
    line-height: 5.641025641025641vw;
  }

  .contacto__cel {
    width: 61.728205128205126vw;
    margin: 10vw 0 0 16.666666666666664vw;
  }

  .contacto__cel a {
    font-size: 2.564102564102564vw;
    line-height: 4.615384615384616vw;
    position: relative;
  }

  /* .contacto__cel a:first-of-type::before,
  .navegacion p:first-of-type::before {
    content: "*";
    position: absolute;
    font-family: "Catou";
    font-style: normal;
    font-weight: 400;
    font-size: 9.387179vw;
    line-height: 2.3871794871794876vw;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #ccc548;
    top: 2.6vw;
    left: -6vw;
  } */

  /* .navegacion p:first-of-type::before {
    top: 3.2vw;
  } */

  .buscador__menu {
    display: flex;
    margin: 12.307692307692308vw 0 20.887179vw 11.025641025641026vw;
  }

  .dflx {
    align-items: center !important;
    justify-content: space-between !important;
  }

  .notis {
    display: none;
  }

  .greenav .notis,
  .upnav .contenedor .notis {
    display: flex;
    /*margin: 10.307692vw 0 0 8.025641vw;
    margin: 12.307692307692308vw 0 20.887179vw 11.025641025641026vw;
    position: absolute;
    top: -2.5vw;
    left: 50%;
    transform: translateX(-11vw);
    */
  }

  .notis {
    position: relative;
    left: 4vw;
  }

  .upnav .bkhome .notis>div:last-of-type,
  .error .notis>div:last-of-type {
    width: 6.815385vw;
    left: -5.70625vw;
    top: 6.4vw;
    height: 4.70625VW;
    background-color: #CCC548;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin: 0 0 0 0;
  }

  .greenav .notis>div:last-of-type {
    width: 6.815385vw;
    left: -5.70625vw;
    top: 6.4vw;
    height: 4.70625VW;
    background-color: #FF3723;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin: 0 0 0 0;
  }

  .buscador__menu>div:first-of-type,
  .notis>div:first-of-type {
    width: 7.6923076923076925vw;
    height: 7.948717948717948vw;
    margin: 0 4.871794871794872vw 0 0;
  }

  .buscador__menu>div:last-of-type {
    width: 4.615384615384616vw;
    left: -6.70625vw;
    top: 5.5vw;
    height: 4.394871794871795vw;
    background-color: #194c06;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .buscador__menu>input {
    width: 64.35897435897436vw;
    height: 8.974358974358974vw;
    background-image: url("../../assets/lupa.svg");
    background-repeat: no-repeat;
    background-color: transparent;
    background-size: 5.128205128205128vw 5.128205128205128vw;
    border-radius: 15.384615384615385VW;
    border: solid 0.7692307692307693VW #ffffff;
    color: #fff9ea;
    padding-left: 11.538461538461538vw;
    background-position: 3.8461538461538463vw center;

    font-family: "Kinetica-Bold";
    font-style: normal;
    font-weight: 700;
    font-size: 2.564102564102564vw;
    line-height: 4.615384615384616vw;
    letter-spacing: 0.15em;
    text-transform: uppercase;
  }

  .buscador__menu input::-webkit-search-cancel-button {
    display: none;
  }

  .buscador__menu>input::placeholder {
    color: #fff9ea;
    opacity: 0.6;
  }

  .despliegue__img {
    margin: 10.923077vw 0 7.6923076923076925vw;
  }

  .despliegue__img>div:first-of-type {
    width: 100vw;
    padding-bottom: 26.6vw;
  }

  .despliegue__img p:first-of-type {
    font-size: 47.923077vw;
    line-height: 78%;
  }

  .despliegue__img p:last-of-type {
    -webkit-text-stroke: 0.2564102564102564VW #f6b801;
    font-size: 20.5vw;
    line-height: 78%;
  }

  .despliegue__img>div:last-of-type {
    width: 81.53846153846153vw;
    height: 117.94871794871796vw;
    position: absolute;
    top: -1vw;
    left: 50%;
    transform: translateX(-50%);
  }

  #backdrop {
    display: none;
  }

  .upnav .contenedor.bkhome {
    padding: 0.564103vw 8.205128205128204vw 0 7.435897435897436vw;
  }

  .nombre {
    left: 10.246667vw;
    top: 11vw;
    display: flex;
  }

  .asterisco--header {
    font-size: 6.7vw;
    height: 5.8vw;
    overflow: hidden;
    margin-right: 3VW;
  }

  .contactos li .asterisco--header {
    margin-left: -6.1vw;
  }

  #despliegue nav .asterisco--header {
    display: none;
  }
}

/* PC */
@media (min-width: 768px) {

  .only-mov {
    display: none;
  }

  #despliegue>div:first-of-type img,
  #despliegue>div:first-of-type sub {
    display: none;
  }

  .contactos {
    display: none;
  }

  .cerrar {
    display: none;
  }

  #despliegue nav {
    margin: 5.625VW 0 2.3958333333333335VW 3.069792VW;
  }

  .barra_buscador {
    margin-bottom: 2.083333333333333VW;
    display: flex;
    justify-content: center;
  }

  .barra_buscador>input {
    border-radius: 5.208333333333334VW;
    border: 0.10416666666666667VW solid #FFF9EA;
    width: calc(20.9375VW - 2.65625VW);
    background-size: 1.3020833333333335VW 1.3020833333333335VW;
    background-position: 0.9895833333333333VW center;
    height: 2.604166666666667VW;
    position: relative;
    padding-left: 2.65625VW;
  }

  .btn {
    top: 0.829167VW;
    left: 4.089583VW;
    width: 1.3020833333333335VW;
    height: 1.3020833333333335VW;
    cursor: pointer;
  }

  #despliegue nav ul li {
    font-size: 1.0416666666666665VW;
    line-height: normal;
    letter-spacing: 0.0625VW;
    position: relative;
    margin-bottom: 0.9895833333333333VW;
    display: flex;
    align-items: center;
  }

  #despliegue nav ul li:last-of-type {
    margin-bottom: 0;
  }

  .barra_buscador>input::placeholder {
    font-size: 0.7vw;
    opacity: 0.6;
  }

  .imagen__botana img {
    width: 23.854166666666668VW;
    height: 28.879167VW;
    bottom: 0;
    right: 1.895833VW;
  }

  .imagen__botana h3 {
    font-size: 15.625VW;
    line-height: 78%;
  }

  .imagen__botana h3:last-of-type {
    -webkit-text-stroke: 0.10416666666666667VW #F6B801;
    /*font-size: 8.779167VW;*/
    font-size: 7.031vw;
    letter-spacing: 0.281vw;
    line-height: 78%;
    margin-top: 0.2vw;
  }


  .notis {
    display: none;
  }

  .greenav .contenedor p.txt {
    color: #194C06 !important;
  }

  .greenav .contacto a,
  .greenav .contacto p {
    color: #194C06 !important;
  }

  /* .greenav .contacto a::before,
  .contenedor .contacto a::before {
   color: #FF3723 !important;
  } */

  /* .upnav .bkhome .contacto a::before,
  .error .contacto a::before {
    color: #CCC548 !important;
  } */

  .error .contacto a,
  .error .contacto p {
    color: #FFF9EA !important;
  }

  .upnav .bkhome .notificaciones>div:last-of-type {
    background-color: #CCC548 !important;
  }

  .error .contenedor .notificaciones>div:last-of-type {
    background-color: #CCC548 !important;
  }

  .contenedor {
    padding: 2.8125vw 5.879167vw 0;
    background-color: #00000000;
    transition: 0.5s;
  }

  .upnav .contenedor.bkhome {
    background-color: #FF3723;
  }

  .upnav .contenedor.ptop1 {
    padding-top: 3.25vw;
  }

  .contenedor.bknav {
    background-color: #fff9ea;
  }

  .error .contenedor.bknav {
    background-color: #FF3723;
  }

  .logo {
    width: 16.5104vw;
    margin: 0 27.2875vw 0 0;
    transition: .5s;
    position: relative;
    top: 0;
  }

  .upnav .logo {
    width: calc(16.5104vw * 1.1);
    top: -1.2vw;
    margin: 0 25.3875vw 0 0;
  }

  .menu {
    width: 2.604166666666667vw;
    height: 1.9270833333333335vw;
    margin: 0 7.677083vw 0 0;
    cursor: pointer;
  }

  .contacto {
    display: flex;
    margin: 0 0.333333vw 0 0;
    width: 31.577083vw;
    /* transform: translateY(-0.7vw); */
  }

  .contacto a,
  .contacto p {
    font-size: 0.5208333333333333vw;
    line-height: 0.9375vw;
  }

  .contacto p {
    display: flex;
    height: fit-content;
    align-items: center;
  }

  .contacto a {
    display: flex;
    height: fit-content;
    align-items: center;
  }

  /* .contacto a::before {
    content: "*";
    font-family: "Catou";
    font-size: 1.875vw;
    line-height: 1.875vw;
    color: #ccc548;
    position: relative;
    top: 0.66vw;
    opacity: 0;
    transition: opacity 0.3s linear;
    margin: 0 0.625vw 0 0.7291666666666666vw;
  } */
  /* 
  .contacto a:hover::before {
    opacity: 1;
    transition: opacity 0.3s linear;
  } */

  .user-n {
    margin-right: 0.781vw;
    align-items: center;
    justify-content: center;
    width: 1.771vw;
    height: 1.979vw;
  }

  .user-n,
  .notificaciones {
    display: flex;
    position: relative;
    height: fit-content;
    cursor: pointer;
  }

  .user-n img {
    width: 1.771vw;
    height: 1.979vw;
    transition: .5s;
  }

  .user-n:hover img {
    width: 1.971vw;
    height: 2.179vw;
  }

  .user-n img.green {
    filter: invert(60%) sepia(11%) saturate(6345%) hue-rotate(70deg) brightness(40%) contrast(80%);
  }

  .notificaciones>div:first-of-type {
    /*width: 2.03125vw;
    height: 2.0385416666666667vw;*/
    width: 1.563vw;
    height: 1.563vw;
  }

  .notificaciones>div:last-of-type {
    width: 0.9375vw;
    left: 0.9375vw;
    top: 1.15vw;
    height: 0.9375vw;
    background-color: #ff3723;
    border-radius: 100%;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .notificaciones img {
    transform: rotate(0deg);
  }

  .notificaciones:hover img {
    animation: rotation-1 1s ease-in-out infinite;
  }

  @keyframes rotation-1 {
    0% {
      transform: rotate(0deg);
    }

    43% {
      transform: rotate(-30deg);
    }

    80% {
      transform: rotate(30deg);
    }

    100% {
      transform: rotate(5deg);
    }
  }

  sub {
    font-size: 0.5208333333333333vw;
    line-height: 0.9375vw;
    margin-top: 0.1vw;
  }

  #despliegue {
    width: 28.645833333333332vw;
    height: 100%;
    right: 0;
    transform: translateX(100%);
  }

  .navegacion {
    margin: 5.625vw 0 0 3.3854166666666665vw;
  }

  /* 
  .navegacion div a::before {
    content: "*";
    position: relative;
    padding: 0vw 1.09375vw 0 0;
    top: 1.3vw;

    font-family: "Catou";
    font-style: normal;
    font-weight: 400;
    font-size: 3.3333333333333335vw;
    line-height: 3.3333333333333335vw;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #ccc548;
    opacity: 0;
    transition: 0.3s linear;
  } */

  /* .navegacion div a:hover::before,
  .navegacion div p:hover::before {
    opacity: 1;
    transition: 0.3s linear;
  } */

  .navegacion a {
    font-size: 1.0416666666666665vw;
    line-height: 1.9270833333333335vw;
  }

  .despliegue__img {
    margin: 7.635416666666668vw auto 0;
  }

  .despliegue__img>div:last-of-type {
    width: 23.854166666666668vw;
    height: 33.279167vw;
  }

  .despliegue__img p {
    font-size: 15.625vw;
    line-height: 78%;
  }

  .despliegue__img p:last-of-type {
    font-size: 7.03125vw;
    line-height: 78%;
    margin: 0.5208333333333333vw 0 0;
    -webkit-text-stroke: 0.10416666666666667VW #f6b801;
  }

  .buscador__menu {
    display: none;
  }

  #backdrop {
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.6);
    position: fixed;
    z-index: 123;
    display: none;
    opacity: 0;
    transition: opacity 0.3s linear;
  }

  #backdrop {
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.6);
    position: fixed;
    z-index: 123;
    display: none;
    opacity: 0;
    transition: opacity 0.3s linear;
  }

  .contacto__cel {
    display: none;
  }

  .contenedor p.txt {
    text-align: center;
    font-size: 0.5208333333333333vw;
    line-height: 0.9375vw;
    font-family: "Kinetica-Bold";
    font-style: normal;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #ffffff;
    padding-bottom: 1vw;
  }

  .nombre {
    font-size: 1.0416666666666665VW;
    line-height: normal;
    letter-spacing: 0.0625VW;
    top: 2.50625VW;
    left: 5.369792VW;
  }

  .asterisco {
    font-size: 1.875VW;
    line-height: 1.875VW;
    margin: 0 0.425VW 0 0.7291666666666666VW;
    height: 1.3vw;
    overflow: hidden;
    opacity: 0;
    transition: opacity 0.3s linear;
  }

  .contacto:has(a:first-of-type:hover) .asterisco:first-of-type {
    opacity: 1;
  }

  .contacto:has(a:last-of-type:hover) .asterisco:last-of-type {
    opacity: 1;
  }

  .asterisco--header {
    font-size: 2.7333333333333335VW;
    letter-spacing: 0.2VW;
    overflow: hidden;
    height: 2.5vw;
    margin-right: 1vw;
    opacity: 0;
    transition: opacity 0.3s linear;
  }

  #despliegue nav ul li:has(a:hover)>span,
  #despliegue nav ul li:has(p:hover)>span {
    opacity: 1;
  }

}
</style>
